import * as React from "react";
​
const Directions: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 6.8 6.8"style={{"enableBackground":"new 0 0 6.8 6.8"} as any} fill="CurrentColor" xmlSpace="preserve">
<g>
	<path d="M3.4,0.2L0.2,3.4l3.3,3.2l3.2-3.2L3.4,0.2z M0.8,3.4l2.6-2.5L6,3.4L3.4,5.9L0.8,3.4z"/>
	<polygon points="3.1,3.2 3.1,4.3 2.7,4.3 2.7,3.2 2.7,2.8 2.7,2.8 4.2,2.8 4.2,3.2 	"/>
	<polygon points="4.1,2.5 4.7,3 4.1,3.6 	"/>
	<path d="M3.4,1.5c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2C3.2,1.6,3.3,1.5,3.4,1.5
		C3.4,1.5,3.4,1.5,3.4,1.5z"/>
	<path d="M3.4,4.8c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.2C3.3,5.2,3.2,5.1,3.2,5C3.2,4.9,3.3,4.8,3.4,4.8L3.4,4.8z"/>
</g>
</svg>;
};
​
export default React.memo(Directions);